import MJSONDesigner from '@admin/components/mjson_designer'
import Panel from '@admin/components/panel'
import React from 'react'

const getMJSONDesigner = (provider) => ({
  editable: true,
  endpoint: `/crm_templates/${provider.template.id}`,
  root_route: '/truevail/admin/template',
  type: 'email',
  versionable: true
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Template)',
  component: <MJSONDesigner { ...getMJSONDesigner(props.provider) } />
})

export default Panel(null, mapPropsToPanel)
